<template>
  <div
    v-if="!authenticated || !hasActiveSubscription"
    class="subscription-incentive-card"
  >
    <div class="content">
      <h2 class="font-bold">Vidéo démo</h2>
      <video-incentive class="mb-5"></video-incentive>
      <presentation-text
        v-if="!hidePresentationText"
        class="mb-5 text-left text-sm"
      ></presentation-text>
      <button
        class="orange-background w-full"
        @click="$router.push({ name: 'offers' })"
      >
        Abonnez-vous
      </button>
    </div>
  </div>
</template>

<script>
import PresentationText from './PresentationText.vue'
import VideoIncentive from './VideoIncentive.vue'
export default {
  components: { PresentationText, VideoIncentive },
  name: 'SubscriptionIncentiveCard',
  props: {
    hidePresentationText: { type: Boolean, default: false }
  },
  computed: {
    authenticated () {
      return this.$store.getters['authent/isAuthenticated']
    },
    hasActiveSubscription () {
      return this.$store.getters['authent/hasActiveSubscription']
    }
  }
}
</script>

<style></style>
